module.exports = __webpack_public_path__ + "img/xmasParty5.c9cc73f3.jpg";